import * as React from 'react';
import { SingleKeyValueComponent } from '../common';
import styles from './long-description.scss';

export const LongDescription = (props:SingleKeyValueComponent<number>) => {
  const { className, componentId, valueItem } = props;
  const hasLongDescription = !!valueItem && !!valueItem.longDescription;

  return (
    !!hasLongDescription &&
      <p id={componentId} className={`col-12 ${styles.longDescription} ${className}`}>
        {valueItem.longDescription}
      </p>
  );
};
